// Renders JSON-LD structured data. Google parses ld+json anywhere in the DOM.
// Escape "<" so a value containing "</script>" cannot break out of the tag.
export const JsonLd = ({ data }) => (
  <script
    type="application/ld+json"
    dangerouslySetInnerHTML={{ __html: JSON.stringify(data).replace(/</g, "\\u003c") }}
  />
);
